import { createGlobalStyle } from 'styled-components';

// The ONE permitted home for `.ant-*` selectors (CLAUDE.md rule 12): the few
// rules of the 2026-09-24 light-mode polish (spec §14) that no ConfigProvider
// token can express — the resting card lift, the display face (Gabarito Bold) on antd titles,
// the table head as an uppercase kicker, the tag pill metrics and the
// light-mode tag border that derives from its own text. Colours only through
// var(--odin-*) / theme.*; never a literal. Mounted in App.jsx (and the dev
// harness) immediately after GlobalStyles.
export const AntdOverrides = createGlobalStyle`
  /* Resting lift; the hover lift is the boxShadowCard token */
  .ant-card {
    box-shadow: var(--odin-shadow-card);
  }

  .ant-card-head-title,
  .ant-modal-title,
  .ant-drawer-title {
    font-family: ${({ theme }) => theme.typography.fontFamily.display};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    letter-spacing: -0.015em;
    color: var(--odin-ink);
  }

  /* Header row as an uppercase Gabarito kicker on the strong hairline, not a filled band.
     (0,4,3) so it out-specifies antd's own .ant-table-wrapper .ant-table-thead > tr > th
     rule AND its size variants (.ant-table.ant-table-middle / -small, (0,4,2)) for the
     border colour and padding, whichever sheet lands first. */
  .ant-table-wrapper .ant-table .ant-table-container table > .ant-table-thead > tr > th {
    font-size: 11.5px;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    letter-spacing: 0.07em;
    text-transform: uppercase;
    border-bottom-color: var(--odin-border-strong);
    padding-block: 8px 10px;
  }

  /* Status chips: pill metrics (the radius is the Tag.borderRadiusSM token) */
  .ant-tag {
    padding-inline: 9px;
    line-height: 20px;
    font-size: 12px;
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    margin-inline-end: 6px;
  }

  /* Light: every preset's border derives from its own text, so twelve presets
     plus the info triple stay one system without per-colour border tokens */
  html[data-theme="light"] .ant-tag:not(.ant-tag-borderless) {
    border-color: color-mix(in srgb, currentColor 22%, transparent);
  }

  .ant-tabs-tab {
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  }

  .ant-tabs-ink-bar {
    height: 2px;
    border-radius: 2px;
  }

  .ant-alert {
    border-radius: 10px;
  }
`;

export default AntdOverrides;
